module.exports = __webpack_public_path__ + "static/1-dc7c7bae9a989de38fd6d146ddbb884c.jpg";